<template>
  <div id="Story" class="container-xl header-large FoundersGrotesk">
    <div class="desktop">
      <div v-for="(rowData, index) in dataRows" :key="index" class="mb-5 h-100">
        <b-row class="h-100">
          <b-col
            class="h-100 m-0 p-0"
            cols="12"
            md="6"
            :order="rowData.reverseColumns ? 2 : 1"
          >
            <img
              :src="rowData.imageSrc"
              :alt="rowData.imageAlt"
              class="d-block img-fluid border-img"
            />
          </b-col>
          <b-col
            class="p-0"
            cols="12"
            md="6"
            :order="rowData.reverseColumns ? 1 : 2"
          >
            <div class="center-text">
              <div class="w-75">
                <div
                  v-html="formatText(rowData.header)"
                  class="lg-event-text"
                ></div>
                <div v-for="(item, idx) in rowData.list" :key="idx">
                  {{ item }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="mobile">
      <div
        v-for="(rowData, index) in dataRowsMobile"
        :key="index"
        class="mb-5 h-100"
      >
        <b-row class="h-100">
          <b-col
            class="h-100 m-0 p-0"
            cols="12"
            md="6"
            :order="rowData.reverseColumns ? 2 : 1"
          >
            <img
              :src="rowData.imageSrc"
              :alt="rowData.imageAlt"
              class="d-block img-fluid border-img"
            />
          </b-col>
          <b-col
            class="p-0"
            cols="12"
            md="6"
            :order="rowData.reverseColumns ? 1 : 2"
          >
            <div class="center-text">
              <div>
                <div
                  v-html="formatText(rowData.header)"
                  class="lg-event-text pb-3"
                ></div>
                <div v-for="(item, idx) in rowData.list" :key="idx">
                  {{ item }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
  data() {
    return {
      dataRows: [
        {
          imageSrc: "/img/roof/Seated.jpg",
          imageAlt: "Image 1",
          header: "THE FEATURES",
          list: [
            "Original art from local artists",
            "Surround sound system",
            "Banquet seating",
            "In house caterer",
            "Dj and photographer AUR",
          ],
          reverseColumns: false,
        },
        {
          imageSrc: "/img/roof/TableSpread.jpg",
          imageAlt: "Image 1",
          header: "CAPACITIES",
          list: [
            "30 sit down dinner 50 standing",
            "Cocktail-style with food stations \n\n and/or passed bites",
          ],
          reverseColumns: true,
        },
        {
          imageSrc: "/img/roof/TableCloseUp.jpg",
          imageAlt: "Image 1",
          header: "GOOD TO KNOW",
          list: [
            "Available for booking April - October",
            "All events must end by 10pm out of courtesy to our neighbours",
            "Rooftop is not covered and is unheated",
          ],
          reverseColumns: false,
        },
        {
          imageSrc: "/img/roof/DeckMuralCloseUp.jpg",
          imageAlt: "Image 1",
          header: "SPEND THE NIGHT WITH US!",
          list: [
            "Need rooms? We thought so! All rooftop bookings come with a discounted room rate, so that you can stay steps away from your soiree.",
          ],
          reverseColumns: true,
        },
      ],
      dataRowsMobile: [
        {
          imageSrc: "/img/roof/Seated.jpg",
          imageAlt: "Image 1",
          header: "THE FEATURES",
          list: [
            "Original art from local artists",
            "Surround sound system",
            "Banquet seating",
            "In house caterer",
            "Dj and photographer AUR",
          ],
          reverseColumns: false,
        },
        {
          imageSrc: "/img/roof/TableSpread.jpg",
          imageAlt: "Image 1",
          header: "CAPACITIES",
          list: [
            "30 sit down dinner 50 standing",
            "Cocktail-style with food stations \n\n and/or passed bites",
          ],
          reverseColumns: false,
        },
        {
          imageSrc: "/img/roof/TableCloseUp.jpg",
          imageAlt: "Image 1",
          header: "GOOD TO KNOW",
          list: [
            "Available for booking April - October",
            "All events must end by 10pm out of courtesy to our neighbours",
            "Rooftop is not covered and is unheated",
          ],
          reverseColumns: false,
        },
        {
          imageSrc: "/img/roof/DeckMuralCloseUp.jpg",
          imageAlt: "Image 1",
          header: "SPEND THE NIGHT WITH US!",
          list: [
            "Need rooms? We thought so! All rooftop bookings come with a discounted room rate, so that you can stay steps away from your soiree.",
          ],
          reverseColumns: false,
        },
      ],
    };
  },
  components: {},
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh();
    setTimeout(() => {}, 500);
  },
  methods: {
    formatText(text) {
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.header-large {
  padding: 50px 50px 100px 50px;
  position: relative;
  @media screen and (max-width: 1176px) {
    padding: 40px 40px 50px 40px;
  }
  .lg-event-text {
    font-size: 32px;
    padding-bottom: 40px;
    line-height: 1em;
    @media screen and (max-width: 850px) {
      font-size: 32px;
    }
    @media screen and (max-width: 600px) {
      font-size: 28px;
    }
  }
  .center-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    @media screen and (min-width: 900px) {
      padding: 0px 35px;
    }
    @media screen and (max-width: 767px) {
      padding: 25px 0px 0px 0px;
    }
    @media screen and (max-width: 500px) {
      padding: 25px 0px 0px 0px;
      justify-content: left;
    }
  }
  img {
    width: 555px;
  }
  .border-img {
    border: 2px solid black;
  }
  .mobile {
    display: none;
    @media screen and (max-width: 767px) {
      display: block;
    }
  }
  .desktop {
    display: block;
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
}
</style>
